import { App as CapacitorApp } from '@capacitor/app';
import { isNativeShell } from '../auth/authRedirect';

const ALLOWED_HOSTS = new Set(['sacmetrolinemedic.app', 'www.sacmetrolinemedic.app']);
const ALLOWED_PATHS = [
  /^\/$/,
  /^\/gear\//i,
  /^\/asset\//i,
  /^\/handoff\//i,
  /^\/account\//i,
  /^\/my-gear\/?$/i,
  /^\/tracking\/?$/i,
  /^\/saved-iaps\/?$/i,
  /^\/program-feed(?:\/|$)/i,
  /^\/prescribed-burns(?:\/|$)/i,
  /^\/rems-access(?:\/|$)/i,
  /^\/restock-approval\/?$/i,
  /^\/admin(?:\/|$)/i,
  /^\/inventory-admin\/?$/i,
  /^\/settings\/?$/i,
  /^\/app-review-demo\/?$/i,
];

function routeFromUniversalLink(rawUrl) {
  try {
    const url = new URL(rawUrl);
    if (!ALLOWED_HOSTS.has(url.hostname.toLowerCase())) return false;
    if (!ALLOWED_PATHS.some(pattern => pattern.test(url.pathname))) return false;
    // Gear-tag Universal Links should enter the authenticated My Gear workflow
    // instead of loading the public recovery page inside the native WebView.
    const assetMatch = url.pathname.match(/^\/(?:gear|asset)\/([^/]+)\/?$/i);
    const target = assetMatch
      ? `/my-gear?asset=${encodeURIComponent(decodeURIComponent(assetMatch[1]))}&source=tag`
      : `${url.pathname}${url.search}${url.hash}` || '/';

    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    // Never reload the Capacitor WebView for an internal native route.
    if (current !== target) {
      window.history.replaceState({}, '', target);
    }

    window.dispatchEvent(new Event('smfd:native-route'));
    return true;
  } catch (_) {
    return false;
  }
}

export async function installNativeLifecycleBridge() {
  if (typeof window === 'undefined' || !isNativeShell()) return false;

  try {
    await CapacitorApp.addListener('appUrlOpen', event => {
      routeFromUniversalLink(event?.url || '');
    });

    await CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      if (isActive) window.dispatchEvent(new CustomEvent('smfd:native-resume'));
    });

    const launch = await CapacitorApp.getLaunchUrl();
    if (launch?.url) routeFromUniversalLink(launch.url);
    return true;
  } catch (_) {
    return false;
  }
}

export { routeFromUniversalLink };
